import { useCallback, useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import _ from "lodash"
import { useVenue } from "providers/venue"
import { Q_VENUE } from "../constant"

type FilterByVenueId = (venueId: string) => void

interface IUseTouristResult {
  filteredTouristByVenue: IFilteredTouristByVenue[]
}

interface ITourist {
  id: string
  image: string
  location: {
    id: string
  }
  name: {
    en: string
  }
}

interface IFilteredTouristByVenue extends ITourist {
  venue_id: string
  level_name: string
}

type UseTourist = (
  tourist: ITourist[],
  venueFilter?: string
) => IUseTouristResult

export const useTourist: UseTourist = (tourist, venueFilter) => {
  const [, setSearchParams] = useSearchParams()
  const { findFeatureById } = useVenue()

  const filterByVenueId: FilterByVenueId = useCallback(
    (venueId) => {
      if (venueId) setSearchParams({ [Q_VENUE]: venueId }, { replace: true })
    },
    [setSearchParams]
  )

  const preparedTourist = useMemo(
    () =>
      _.map(tourist, (location) => {
        const featureId = _.get(location, "location.id")
        const levelName = _.get(
          findFeatureById(featureId),
          "properties.level_name"
        )
        const venueId = _.get(findFeatureById(featureId), "properties.venue_id")
        return { ...location, level_name: levelName, venue_id: venueId }
      }),
    [tourist, findFeatureById]
  )

  const filteredTouristByVenue = useMemo(
    () => preparedTourist.filter(({ venue_id }) => venueFilter === venue_id),
    [preparedTourist, venueFilter]
  )

  return {
    filterByVenueId,
    filteredTouristByVenue,
  }
}
